import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
  ChangeDetectorRef,
} from '@angular/core';
import { Questions, SelectedOptionList } from 'src/app/common-class/questions';
import { Group, Matrix } from 'src/app/common-class/pages';
import { Answers } from 'src/app/common-class/answers';
import { CommonLogic } from 'src/app/COMMON-LOGIC/common-logic';
import { ParticipationDataService } from 'src/app/_services/participation-data.service';
import { PreviewData } from 'src/app/common-class/survey';
declare const $: any;

@Component({
  selector: 'app-grid-questions',
  templateUrl: './grid-questions.component.html',
  styleUrls: ['./grid-questions.component.css'],
})
export class GridQuestionsComponent implements OnInit {
  @Input() JsonData: string;
  @Input() isMandatoryUpfront: boolean;
  @Input() isDisplayQno: boolean;
  @Input() group: Group;
  @Input() matrix: Matrix;
  @Input() isSubmitted: boolean;
  @Input() isMobile: boolean;
  @Input() isNewParticipationButton: boolean;
  @Output() ChangeAnswersData: EventEmitter<Questions> = new EventEmitter<Questions>();

  questions: Questions[];
  firstQuestion: Questions;
  imageQuestion: Questions;
  questionsArray: any;
  isStandAlone: boolean;
  mainQuestionWidth: any;
  mainQuestionWidthString: any;
  subQuestionWidth: any;
  totalWidth: any;
  fullWidthPx: number;
  islayoutfixed: boolean;
  isPreview: boolean;
  isNewParticipation: boolean;
  surveyFormat: number = 0;
  newParticipationBtnText: string;
  showNewParticipationButton: boolean;
  isAutoScroll: boolean;
  isAnsChange: boolean = false;
  resetPageSub: any;
  isDisplayedPipeMessage: boolean;
  isNgOnChange: boolean;
  ngCount: number = 0;
  isAnswerPipingSubChar: boolean;
  isRTL: boolean = false;
  preview: PreviewData;

  setPreviewData(preview: PreviewData) {
    this.preview = preview;
  }
  
  ngOnChanges(changes: SimpleChanges) {
    let change = changes['JsonData'];

    if (change != undefined) {
      let curVal = JSON.stringify(change.currentValue);
      let preVal = JSON.stringify(change.previousValue);
      if (curVal != preVal && preVal != undefined) {
        this.onLoadFilterObject();
        if (this.questions.length > 0) {
          if (this.questions[0].answer_style == 2) {
            this.questions = CommonLogic.RandomQuestionsAnswerHandling(this.questions);
          }
          if (!this.isStandAlone && !this.isMobile) {
            this.isNgOnChange = true;
            this.ngCount = 1;

            if (this.group.answer_style == 2) {
              this.questions = CommonLogic.RandomQuestionsHandling(this.questions);
            }
            this.SortQuestions();
            this.ngAfterViewInit();
          } else {
            if (this.group.answer_style == 2) {
              this.questions = CommonLogic.RandomQuestionsHandling(this.questions);
            }

            if (this.isAnswerPipingSubChar) {
              for (let i = 0; i < this.questions.length; i++) {
                this.questions[i].subQnoinChar = CommonLogic.Convert_To_Alpha(i + 1);
              }
            }
          }
          if (this.group.isAnchorReverse && this.questions[0].qtype == 'RG') {
            for (const question of this.questions) {
              if (this.isMobile) {
                if (!(question.qsubtype == 1 && this.isRTL)) {
                  question.Answers.sort((n1, n2) => n2.weight - n1.weight);
                }
                question.isAnchorReverse = true;
              } else {
                question.Answers.sort((n1, n2) => n2.weight - n1.weight);
              }
            }
            
          }          
          this.questions = this.questions.filter((e) => !e.isHiddenQ);
        }
      }
    }
  }

  constructor(
    private service: ParticipationDataService,
    private changeDetect: ChangeDetectorRef,
    private previewData: PreviewData,
  ) {}

  ngOnInit() {
    if (this.questions == null) {
      this.onLoadFilterObject();
    this.questions = this.questions.filter((e) => !e.isHiddenQ);
      this.isRTL = this.service.getRTL();
      this.isPreview = this.service.GroupType.toUpperCase() == 'PREVIEW';
      if (this.questions.length > 0) {
        if (this.group.answer_style == 2) {
          this.questions = CommonLogic.RandomQuestionsHandling(this.questions);
        } else if (this.group.answer_style == 1 && this.questions[0].grpRotateIndex != -1) {
          this.questions.sort((n1, n2) => n1.sub_qno - n2.sub_qno);
          CommonLogic.RotateQuestionsHandling(this.questions);
        }
        if (this.questions[0].answer_style == 2) {
          this.questions = CommonLogic.RandomQuestionsAnswerHandling(this.questions);
        }

        if (this.group.isAnchorReverse && this.questions[0].qtype == 'RG') {
          for (const question of this.questions) {
            if (this.isMobile) {
              if (!(question.qsubtype === 1 && this.isRTL)) {
                question.Answers.sort((n1, n2) => n2.weight - n1.weight);
              }
              question.isAnchorReverse = true;
            } else {
              question.Answers.sort((n1, n2) => n2.weight - n1.weight);
            }
          }
        } else if (
          this.group.isAnchorReverse &&
          (this.questions[0].qtype == 'GR' || this.questions[0].qtype == 'SR') &&
          this.questions[0].qsubtype == 2
        ) {
          for (const question of this.questions) {
            question.Answers.sort((n1, n2) => n2.value_id - n1.value_id);
          }
        }

        let standAloneQn = this.questions.find((e) => e.qtype == 'SR' || e.qtype == 'SC');

        if ((standAloneQn != null && standAloneQn != undefined) || this.isMobile) {
          this.isStandAlone = true;

          if (this.isAnswerPipingSubChar) {
            for (let i = 0; i < this.questions.length; i++) {
              this.questions[i].subQnoinChar = CommonLogic.Convert_To_Alpha(i + 1);
            }
          }
        } else {
          this.SortQuestions();
        }

        this.mainQuestionWidth = this.matrix.subq_col_width;
        this.subQuestionWidth = this.group.colwidth;
        this.totalWidth = this.mainQuestionWidth + this.subQuestionWidth;

        if (this.mainQuestionWidth == 0) {
          this.mainQuestionWidthString = '253px';
        } else {
          let fullWidth = $('.questions-wrapper').outerWidth();
          this.mainQuestionWidthString = (fullWidth * this.matrix.subq_col_width) / 100 + 'px';
        }

        if (this.totalWidth === 0) {
          this.totalWidth = 100;
        }

        this.fullWidthPx = $('.questions-wrapper').width();
        let vQuestions = this.questions.filter(
          (e) => e.population_type != 2 && e.population_type != 5,
        );
        if (vQuestions.length > 0) this.islayoutfixed = vQuestions[0].uniform_width;
        else this.islayoutfixed = this.questions[0].uniform_width;
        this.isNewParticipation = this.service.isNewParticipation;
        this.surveyFormat = this.service.surveyFormat;
        this.newParticipationBtnText = this.service.newParticipationBtnText;
        this.showNewParticipationButton =
          (this.questions.length != 1 || !this.service.isAutoScroll) &&
          this.isNewParticipationButton;
        if (this.questions.filter((e) => e.population_type == 3).length > 0) {
          this.isAnsChange = true;
        }
        this.isAutoScroll = this.service.isAutoScroll;
      }
    }
  }

  onLoadFilterObject() {
    this.questions = JSON.parse(this.JsonData);

    if (
      this.previewData != undefined &&
      this.service.getPrevPgChnge() &&
      this.questions[0].AnsPipeCondition != 0 &&
      this.questions[0].AnsPipeCondition != 1 &&
      this.questions[0].AnsPipeCondition != 3 &&
      this.questions[0].AnsPipeCondition != 4 &&
      this.questions.find((e) => e.isMultiQuestionPiping) == undefined
    ) {
      this.isDisplayedPipeMessage = true;
    } else {
      this.isDisplayedPipeMessage = false;
    }
    let fQuestions = this.questions.filter((e) => e.population_type != 2 && e.population_type != 5);
    let fstQn;
    if (
      fQuestions &&
      fQuestions.length > 0 &&
      !(
        this.service.getGroupType().toLowerCase() == 'preview' &&
        this.service.getPreviewData().isShowHiddenQN
      )
    ) {
      fstQn = fQuestions[0];
    } else fstQn = this.questions[0];

    if (fstQn != undefined && fstQn != null) {
      this.firstQuestion = fstQn;
    }
    let imgQn = this.questions.find((e) => e.sub_qno == 1);
    if (imgQn != undefined && imgQn != null) {
      this.imageQuestion = imgQn;
    }

    if (this.questions.find((e) => e.AnsPipeCondition > 1) != undefined && this.isDisplayQno) {
      this.isAnswerPipingSubChar = true;
    } else {
      this.isAnswerPipingSubChar = false;
    }

    this.questions = this.questions.filter((e) => !e.isMultiQuestionPiping);
  }

  ngAfterViewInit() {
    if (window.navigator.userAgent.indexOf('Chrome') != -1) {
      $('.answerParent').css('width', 'calc(100% + 1px)');
    }
    if (this.questions.length == 0) {
      return;
    }

    const self = this;

    let elemid = '#dv_' + self.firstQuestion.UniqueNumber;
    $(document).ready(function () {
      $('.fieldset-wrapper-scroll').scroll(function () {
        if ($('.RTLDir').length > 0) {
          if (
            $(this).find('.answer-option-wrapper').outerWidth() + $(this).scrollLeft() <=
            $(this).outerWidth() + 5
          ) {
            $(this).parents('.divScroll').find('.div-scroll-btn').hide();
          } else if (
            $(this).find('.answer-option-wrapper').outerWidth() + $(this).scrollLeft() >
            $(this).outerWidth() + 5
          ) {
            $(this).parents('.divScroll').find('.div-scroll-btn').show();
          }
        } else {
          if (
            $(this).find('.answer-option-wrapper').outerWidth() - $(this).scrollLeft() <=
            $(this).outerWidth() + 5
          ) {
            $(this).parents('.divScroll').find('.div-scroll-btn').hide();
          } else {
            $(this).parents('.divScroll').find('.div-scroll-btn').show();
          }
        }
      });

      setTimeout(() => {
        if (self.islayoutfixed) {
          $(elemid)
            .find('.sub-category-table')
            .each(function () {
              self.setColumnWidth($(this));
            });
        } else {
          $(elemid)
            .find('.sub-category-table')
            .each(function () {
              self.checkColumnWidth($(this), elemid);
            });
        }
      }, 0);

      setTimeout(() => {
        if (
          $(elemid).find('.answer-option-wrapper').outerWidth() > $(elemid).outerWidth() ||
          ($(elemid).find('.answer-option-wrapper').outerWidth() >
            $(elemid).find('.fieldset-wrapper-scroll-cont').outerWidth() &&
            this.totalWidth < 100)
        ) {
          $(elemid).find('.div-scroll-btn').show();
        }
      }, 450);
    });
    this.resetPageSub = this.service.emitResetPageEvent.subscribe((data) => {
      if (data) {
        this.isAnsChange = false;
      }
    });
  }

  ngOnDestroy() {
    if (this.resetPageSub) {
      this.resetPageSub.unsubscribe();
    }
  }

  radioButtonChangeCall(question: Questions, answer: Answers, event: Event) {
    let radioid =
      'lbl_Q' + question.qno + '_' + question.UniqueNumber + '_R_' + answer.value_id + '_ID';

    if (answer.selectdId == 0) {
      $('#' + radioid).prop('checked', true);
      answer.ControlAns = answer.value_text;
      question.Answers[
        question.Answers.indexOf(question.Answers.find((e) => e.ms_id == answer.ms_id))
      ] = answer;
      this.questions[
        this.questions.indexOf(this.questions.find((e) => e.UniqueNumber == question.UniqueNumber))
      ] = question;
      this.RadioButtonSelectedValue(answer, question);
    } else {
      $('#' + radioid).prop('checked', false);
      this.RadioButtonClickEventHandling(answer, question);
    }
  }

  SortQuestions() {
    if (this.group.answer_style != 2 && this.group.answer_style != 1) {
      this.questions.sort((n1, n2) => n1.sub_qno - n2.sub_qno);
    } else {
      this.questions.sort((n1, n2) => n1.qno - n2.qno && n1.sub_qno - n2.sub_qno);
    }

    let unique = this.questions
      .map((e) => e.sub_qno)
      .filter((value, index, self) => self.indexOf(value) === index);

    let questionsArray = [];
    for (let i = 0; i < unique.length; i++) {
      let questions = this.questions.filter((e) => e.sub_qno == unique[i]);

      if (questions.length > 0) {
        if (this.isAnswerPipingSubChar) {
          questions[0].subQnoinChar = CommonLogic.Convert_To_Alpha(i + 1);
        }
        questionsArray.push(questions);
      }
    }
    this.questionsArray = questionsArray;
  }

  getHiddenQuestions(questions: Questions, service: ParticipationDataService) {
    if (
      service.getGroupType().toLowerCase() == 'preview' &&
      service.getPreviewData().isShowHiddenQN
    ) {
      return true;
    } else {
      return (
        (
        questions[0].population_type != 2 &&
        questions[0].population_type != 5 &&
        !questions[0].isCQHide) ||
        service.getisEditResponse()
      );
    }
  }

  getHiddenQuestionsMobile(questions: Questions, service: ParticipationDataService) {
    if (
      service.getGroupType().toLowerCase() == 'preview' &&
      service.getPreviewData().isShowHiddenQN
    ) {
      return true;
    } else {
      return (
        (
        questions.population_type != 2 &&
        questions.population_type != 5 &&
        !questions.isCQHide) ||
        service.getisEditResponse()
      );
    }
  }

  RadioButtonSelectedValue(answer: Answers, question: Questions) {
    for (let i = 0; i < question.Answers.length; i++) {
      if (answer.ms_id === question.Answers[i].ms_id) {
        answer.selectdId = 1;
        answer.ControlAns = answer.value_text;
        question.Answers[i] = answer;
        question.AnswerID = answer.ms_id;
        question.selectAnsValue = answer.value_id;
        question.AnswerText = answer.value_text;
        question.pageto = answer.pageto;
        question.otherAnswer = null;

        if (question.isSoftRequired) {
          question.isSoftRequiredHandle = true;
        }

        if (answer.isOther) {
          question.isOtherAnswer = true;
        } else {
          question.isOtherAnswer = false;
        }
      } else {
        question.Answers[i].ControlAns = null;
        question.Answers[i].selectdId = 0;
      }
    }
    this.changeDetect.detectChanges();
    this.UpdateQuestionsData(question);
  }

  RadioButtonClickEventHandling(answer: Answers, question: Questions) {
    if (answer.selectdId == 0) {
      return;
    }

    if (this.questions != null) {
      answer.selectdId = 0;
      answer.ControlAns = null;
      let updateItem = question.Answers.find((e) => e.ms_id == answer.ms_id);
      let index = question.Answers.indexOf(updateItem);
      question.Answers[index] = answer;
      question.AnswerID = 0;
      question.selectAnsValue = 0;
      question.pageto = 0;
      question.AnswerText = null;
      question.otherAnswer = null;
      question.isOtherAnswer = false;
      this.changeDetect.detectChanges();
      this.UpdateQuestionsData(question);
      if (question.isSoftRequired) {
        question.isSoftRequiredHandle = false;
      }
    }
  }

  CheckBoxSelectedValue(answer: Answers, event: any, question: Questions) {
    question.isAlertDanger = false;

    let updateItem = question.Answers.find((e) => e.ms_id == answer.ms_id);
    let index = question.Answers.indexOf(updateItem);

    if (event) {
      this.AddSelectedValueList(answer, question);
      answer.selectdId = 1;
      question.Answers[index] = answer;
      question.pageto = answer.pageto;
      question.otherAnswer = null;

      if (question.isSoftRequired) {
        question.isSoftRequiredHandle = true;
      }

      if (answer.isOther) {
        question.isOtherAnswer = true;
      }
    } else {
      this.RemoveSelectedList(answer, question);

      answer.selectdId = 0;
      answer.ControlAns = null;

      if (answer.IsNoneAbove) {
        question.isValid = false;
      }
      question.Answers[index] = answer;
      question.AnswerID = 0;
      question.selectAnsValue = 0;

      if (question.selectedOptionList != null && question.selectedOptionList.length == 0) {
        question.pageto = 0;
      }

      if (question.isSoftRequired) {
        question.isSoftRequiredHandle = false;
      }

      if (answer.isOther) {
        question.isOtherAnswer = false;
        question.otherAnswer = null;
      }
    }

    if (question.selectedOptionList.length > 0) {
      question.AnswerText = 'Selected Answer Option';
    } else {
      question.AnswerText = null;
    }
    this.changeDetect.detectChanges();
    this.UpdateQuestionsData(question);
  }

  AddSelectedValueList(answer: Answers, question: Questions) {
    let selectedOptionList: SelectedOptionList[];
    if (question.selectedOptionList != null && question.selectedOptionList != undefined) {
      selectedOptionList = question.selectedOptionList;
    } else {
      selectedOptionList = [];
    }
    selectedOptionList.push({
      value_id: answer.value_id,
      value_text: answer.value_text,
      isOther: answer.isOther,
    });
    question.selectedOptionList = selectedOptionList;
  }

  RemoveSelectedList(answer: Answers, question: Questions) {
    let selectedOptionList: SelectedOptionList[];
    if (question.selectedOptionList != null && question.selectedOptionList != undefined) {
      selectedOptionList = question.selectedOptionList;
      let selectedList = selectedOptionList.find((e) => e.value_id == answer.value_id);
      let curIndex = selectedOptionList.indexOf(selectedList);
      if (curIndex >= 0) {
        selectedOptionList.splice(curIndex, 1);
      }
    } else {
      selectedOptionList = [];
    }
    question.selectedOptionList = selectedOptionList;
  }

  RatingScaleHeaderText(question: Questions, index: number, answer: Answers): string {
    if (answer.value_id == 1) {
      return this.group.L_text;
    } else if (this.group.M_Pos == parseInt(answer.value_text)) {
      return this.group.M_text;
    } else {
      let max = question.Answers.reduce((prev, current) =>
        prev.value_id > current.value_id ? prev : current,
      );
      if (max != null && max != undefined) {
        if (max.weight == 0) {
          if (answer.value_text == '') {
            return 'N/A';
          } else if (answer.value_text != null) {
            if (
              max.value_id - 1 == answer.value_id &&
              answer.weight != null &&
              answer.weight != 0
            ) {
              return this.group.H_text;
            } else if (answer.value_text != null && max.value_id == answer.value_id) {
              let value: any = answer.value_text;
              if (answer.value_text.indexOf('N/A') < 0) {
                answer.value_text = value + ' ' + 'N/A';
              }
              return '';
            }
          }
        } else if (max.value_id == answer.value_id && answer.weight != 0) {
          return this.group.H_text;
        }
        return '';
      }
    }
  }

  
  RatingScaleValueText(question: Questions, index: number, answer: Answers): string {

    if(question.RSFormat == 2  && !answer.isNA)
    {
      return "";
    }
    else
    {
      return answer.value_text
    }
    }

    isNAEnable():boolean{
      return this.questions[0].Answers.filter(e => e.isNA).length > 0 ? true : false;
    }

  UpdateQuestionsData(question: Questions) {
    this.isAnsChange = true;
    this.ChangeAnswersData.emit(question);
  }

  GetQuestionsString(question): string {
    if (this.isStandAlone && !this.isMobile) {
      question.isOverAllStyleApplied = false;
    }
    return JSON.stringify(question);
  }

  GetAnswers(): Answers[] {
    return this.questions[0].Answers;
  }

  GetQuestion(): Questions {
    return this.questions[0];
  }

 setColumnWidth(obj) {
    let maxWidth = 0;
    let subCategoryTdWidth = obj.width() / obj.find('.sub-category-td').length;
    obj.find('.sub-category-td').css('width', subCategoryTdWidth + 'px');
    obj.find('.sub-category-td').each(function () {
      if ($(this).outerWidth() > maxWidth) {
        maxWidth = $(this).outerWidth();
      }
    });
    if (maxWidth > 148) {
      maxWidth = 148;
    }
    if(maxWidth <95)
      {
        maxWidth = 95;
      }
    obj.find('.sub-category-td').css('width', maxWidth + 'px');
    obj
      .closest('.main-matrix')
      .find('.gridInputTd')
      .css('width', maxWidth + 'px');
    obj.find('.sub-category-td').css({
      wordBreak: 'break-word',
      wordWrap: 'break-word',
    });
    let tableWidth = obj.find('.sub-category-td').length * maxWidth;
    obj.css('width', tableWidth + 'px');
    obj.css('min-width', '100%');
    obj
      .closest('.main-matrix')
      .find('.gridInputTable')
      .css('width', tableWidth + 'px');
  }

  checkColumnWidth(obj, objId) {
    let widthArray = [];
    let currentWidth;
    let totalWidthPx = 0;
    $(objId).find('.sub-category-table').css('min-width', '100%');
    obj.find('.sub-category-td').each(function (i) {
      if ($(this).outerWidth() < 30) {
        currentWidth = 30;
      } else {
        currentWidth = $(this).outerWidth();
      }
      widthArray[i] = currentWidth;
      totalWidthPx = totalWidthPx + widthArray[i];
    });
    $(objId)
      .find('.controls-tr')
      .each(function () {
        $(this)
          .find('.answer-option')
          .each(function (j) {
            $(this).css('min-width', widthArray[j] - 1 + 'px');
          });
      });

    $(objId).find('.sub-category-table').css('min-width', 'auto');

    if (totalWidthPx < $(objId).find('.sub-category-table').parent().width()) {
      $(objId).find('.sub-category-table').css('width', '100%');
    } else {
      $(objId)
        .find('.sub-category-table')
        .css('width', totalWidthPx + 'px');
    }
    $(objId).find('.sub-category-table').css('min-width', '100%');
  }
  getPipingTitle(group_no: number): string {
    return this.service.getPiping(group_no);
  }

  gotoNextQuestion(question: Questions, event) {
    if (this.isStandAlone) {
      let scrollTargetElement = $('#bodyScroll');
      const checkIfPrevirew = this.service.preview && this.service.preview.viewport;
      let nextbtnLength = $(event)
        .closest('.active-ques')
        .nextAll('.inactive-ques')
        .has('.question-data').length;

      let elemPosition;
      elemPosition = $(event)
        .closest('.matrix-standalone-active-ques' + question.group_no)
        .nextAll('.matrix-standalone-active-ques' + question.group_no);
      if (elemPosition.length > 0) {
        elemPosition = $(event)
          .closest('.matrix-standalone-active-ques' + question.group_no)
          .nextAll('.matrix-standalone-active-ques' + question.group_no)
          .has('.question-data')
          .eq(0)
          .offset().top;
          if(checkIfPrevirew && checkIfPrevirew != ''){
            if(this.service.preview.viewport === "web"){
              elemPosition = elemPosition - scrollTargetElement.offset().top + scrollTargetElement.scrollTop() - $('.toolbar').innerHeight();
            }
            else {
              scrollTargetElement = $('.app-participation');
              elemPosition = elemPosition - scrollTargetElement.offset().top + scrollTargetElement.scrollTop();
            }
          } else {
            elemPosition = elemPosition - scrollTargetElement.offset().top + scrollTargetElement.scrollTop();
          }
          
          scrollTargetElement.animate(
          {
            scrollTop: elemPosition - $(window).height() / 3,
          },
          400,
        );
      } else if (nextbtnLength > 0) {
        elemPosition = $(event)
          .closest('.active-ques')
          .nextAll('.inactive-ques')
          .has('.question-data')
          .eq(0)
          .offset().top;
          if(checkIfPrevirew && checkIfPrevirew != ''){
            if(this.service.preview.viewport === "web"){
              elemPosition = elemPosition - scrollTargetElement.offset().top + scrollTargetElement.scrollTop() - $('.toolbar').innerHeight();
            }
            else {
              scrollTargetElement = $('.app-participation');
              elemPosition = elemPosition - scrollTargetElement.offset().top + scrollTargetElement.scrollTop();
            }
          } else {
            elemPosition = elemPosition - scrollTargetElement.offset().top + scrollTargetElement.scrollTop();
          }
          
          scrollTargetElement.animate(
          {
            scrollTop: elemPosition - $(window).height() / 3,
          },
          400,
        );
      } else {
        if(checkIfPrevirew && checkIfPrevirew != ''){
          if(this.service.preview.viewport === "web"){
            scrollTargetElement = $('#bodyScroll');
          }
          else {
            scrollTargetElement = $('.app-participation');
          }
          } 
        let scrollVal = $('.tblPageFooter').offset().top + scrollTargetElement.scrollTop();

          scrollTargetElement.animate(
          {
            scrollTop: scrollVal,
          },
          400,
        );
      }
    } else {
      this.service.gotoNextQuestion(question, event);
    }
  }

  nextQuestion(event) {
    if (
      this.service.isNewParticipation &&
      (this.service.surveyFormat == 1 || this.service.surveyFormat == 2) &&
      this.questions.length == 1 &&
      this.service.isAutoScroll
    ) {
      this.service.gotoNextQuestion(this.questions[0], event);
    }
  }

  gotoNextQuestionKeyboard(question, event) {
    event.preventDefault();
    this.gotoNextQuestion(question, event.target);
  }

  getAnswerPipeMessage(): string {
    return this.service.getAnswerPipeMessage();
  }

  ngAfterHandle() {
    this.ngCount = 0;
    this.ngAfterViewInit();
  }

    isQuestionsPostPopulated(question: Questions): boolean {
      if((question.population_type == 4 || question.population_type == 5) && this.service.getisEditPostPop()) {
        return true;
      }
      return false;
    }
      isPostEditDisable(question: Questions): boolean {
      if (this.service.getisEditPostPop()
        && (question.population_type != 4 && question.population_type != 5)) {
        return true;
      }
      return false;
    }
}
